export const WALLBOX_EXTRAS_KEYS = [
  "projeto_celesc",
  "projeto_cbmsc",
  "infraestrutura",
  "mao_obra",
  "botao_emergencia",
  "pintura_sinalizacao",
  "sdai",
  "quadro_transferencia",
  "clamper",
  "controladores_carga",
  "move",
] as const;

export type WallboxExtraKey = (typeof WALLBOX_EXTRAS_KEYS)[number];

export type WallboxExtraItem = {
  incluir: boolean;
  valor: number;
  quantidade: number;
};

export type WallboxExtrasProposta = Record<WallboxExtraKey, WallboxExtraItem>;

export type WallboxExtraMeta = {
  label: string;
  helperText: string;
  valorLabel: string;
  pdfLabel: string;
  escopoTexto: string;
};

export const WALLBOX_EXTRAS_META: Record<WallboxExtraKey, WallboxExtraMeta> = {
  projeto_celesc: {
    label: "Projeto e aprovação CELESC",
    helperText: "Inclui o projeto e a aprovação CELESC e soma valor × quantidade ao investimento.",
    valorLabel: "Valor do projeto e aprovação CELESC (R$)",
    pdfLabel: "Projeto e aprovação CELESC",
    escopoTexto: "Projeto e aprovação CELESC",
  },
  projeto_cbmsc: {
    label: "Projeto e aprovação CBMSC",
    helperText: "Inclui o projeto e a aprovação CBMSC e soma valor × quantidade ao investimento.",
    valorLabel: "Valor do projeto e aprovação CBMSC (R$)",
    pdfLabel: "Projeto e aprovação CBMSC",
    escopoTexto: "Projeto e aprovação CBMSC",
  },
  botao_emergencia: {
    label: "Botão de emergência de desligamento central",
    helperText:
      "Seccionamento central da alimentação das estações de recarga. Inclui o item e soma valor × quantidade ao investimento.",
    valorLabel: "Valor do botão de emergência (R$)",
    pdfLabel: "Botão de emergência de desligamento central",
    escopoTexto:
      "Botão de emergência de desligamento central (seccionamento central da alimentação das estações de recarga)",
  },
  pintura_sinalizacao: {
    label: "Pintura de sinalização das vagas",
    helperText:
      "Pintura de sinalização das vagas com estação de recarga (no piso). Inclui o item e soma valor × quantidade ao investimento.",
    valorLabel: "Valor da pintura de sinalização (R$)",
    pdfLabel: "Pintura de sinalização das vagas com estação de recarga (no piso)",
    escopoTexto: "Pintura de sinalização das vagas com estação de recarga (no piso)",
  },
  sdai: {
    label: "Instalação de SDAI",
    helperText:
      "Sistema de Detecção Automática de Incêndio nas áreas de garagem, com ART de projeto e execução dimensionado conforme NBR 17240. Inclui o item e soma valor × quantidade ao investimento.",
    valorLabel: "Valor da instalação de SDAI (R$)",
    pdfLabel: "Instalação de SDAI nas áreas de garagem com ART de projeto e execução",
    escopoTexto:
      "Instalação de SDAI (Sistema de Detecção Automática de Incêndio) nas áreas de garagem, com ART de projeto e execução dimensionado conforme NBR 17240",
  },
  infraestrutura: {
    label: "Infraestrutura (eletrocalhas, dutos e cabeamentos)",
    helperText:
      "Inclui eletrocalhas, dutos e cabeamentos gerais para infraestrutura de recarga e soma valor × quantidade ao investimento.",
    valorLabel: "Valor da infraestrutura (R$)",
    pdfLabel: "Infraestrutura (eletrocalhas, dutos e cabeamentos gerais)",
    escopoTexto: "Infraestrutura (eletrocalhas, dutos e cabeamentos gerais para infraestrutura de recarga)",
  },
  mao_obra: {
    label: "Mão de obra especializada",
    helperText:
      "Inclui a mão de obra especializada de instalação e testes e soma valor × quantidade ao investimento.",
    valorLabel: "Valor da mão de obra especializada (R$)",
    pdfLabel: "Mão de obra especializada (instalação e testes)",
    escopoTexto: "Mão de obra especializada (instalação e testes)",
  },
  quadro_transferencia: {
    label: "Quadro de transferência para derivação",
    helperText:
      "Conformidade com o item 5.4.1.2 da norma I321-0043 CELESC. Inclui o item e soma valor × quantidade ao investimento.",
    valorLabel: "Valor do quadro de transferência (R$)",
    pdfLabel: "Instalação de quadro de transferência para derivação",
    escopoTexto:
      "Instalação de quadro de transferência para derivação (conformidade com o item 5.4.1.2 da norma I321-0043 CELESC)",
  },
  clamper: {
    label: "Clamper Mobi Box Smart",
    helperText: "Inclui a caixa Clamper Mobi Box Smart e soma valor × quantidade ao investimento.",
    valorLabel: "Valor da Clamper Mobi Box Smart (R$)",
    pdfLabel: "Clamper Mobi Box Smart",
    escopoTexto: "Clamper Mobi Box Smart",
  },
  controladores_carga: {
    label: "Controladores de carga",
    helperText: "Inclui os controladores de carga e soma valor × quantidade ao investimento.",
    valorLabel: "Valor do controlador de carga (R$)",
    pdfLabel: "Controladores de carga",
    escopoTexto: "Controladores de carga",
  },
  move: {
    label: "movE Smart Charging",
    helperText:
      "Substitui a plataforma Mobi Driver nesta proposta. Kit de balanceamento de carga: medidor, transformadores de corrente e otimizador movE. Não combine com a Clamper Mobi Box Smart.",
    valorLabel: "Valor do kit movE Smart Charging (R$)",
    pdfLabel: "movE Smart Charging — balanceamento de carga",
    escopoTexto:
      "movE Smart Charging: balanceamento de carga com medidor, transformadores de corrente, otimizador de demanda movE e movE smarter para carregadores sem OCPP",
  },
};

export const WALLBOX_EXTRAS_PROJETO_KEYS: WallboxExtraKey[] = [
  "projeto_celesc",
  "projeto_cbmsc",
];

export const WALLBOX_EXTRAS_COMPLEMENTARES_KEYS: WallboxExtraKey[] = [
  "infraestrutura",
  "mao_obra",
  "botao_emergencia",
  "pintura_sinalizacao",
  "sdai",
  "quadro_transferencia",
  "clamper",
  "controladores_carga",
];

export const WALLBOX_MODO3_NBR_TEXTO =
  "A estação de recarga cotada é do tipo Wallbox Modo 3 com certificado de conformidade (NBR IEC 61851).";

export function itemPadraoExtraWallbox(): WallboxExtraItem {
  return { incluir: false, valor: 0, quantidade: 1 };
}

export function extrasPadraoWallboxProposta(): WallboxExtrasProposta {
  return {
    projeto_celesc: itemPadraoExtraWallbox(),
    projeto_cbmsc: itemPadraoExtraWallbox(),
    infraestrutura: itemPadraoExtraWallbox(),
    mao_obra: itemPadraoExtraWallbox(),
    botao_emergencia: itemPadraoExtraWallbox(),
    pintura_sinalizacao: itemPadraoExtraWallbox(),
    sdai: itemPadraoExtraWallbox(),
    quadro_transferencia: itemPadraoExtraWallbox(),
    clamper: itemPadraoExtraWallbox(),
    controladores_carga: itemPadraoExtraWallbox(),
    move: itemPadraoExtraWallbox(),
  };
}

export function valorExtraWallbox(valor: number | null | undefined): number {
  return Math.max(0, Number(valor) || 0);
}

export function quantidadeExtraWallbox(quantidade: number | null | undefined): number {
  const n = Number(quantidade);
  return Number.isFinite(n) && n >= 1 ? Math.floor(n) : 1;
}

export function subtotalExtraWallbox(item: WallboxExtraItem): number {
  if (!item.incluir) return 0;
  return valorExtraWallbox(item.valor) * quantidadeExtraWallbox(item.quantidade);
}

export function somaExtrasWallboxProposta(extras: WallboxExtrasProposta): number {
  return WALLBOX_EXTRAS_KEYS.reduce((acc, key) => acc + subtotalExtraWallbox(extras[key]), 0);
}

export function extrasWallboxIncluidos(
  extras: WallboxExtrasProposta
): Array<{
  key: WallboxExtraKey;
  item: WallboxExtraItem;
  subtotal: number;
  meta: WallboxExtraMeta;
}> {
  return WALLBOX_EXTRAS_KEYS.flatMap((key) => {
    const item = extras[key];
    if (!item.incluir) return [];
    return [
      {
        key,
        item,
        subtotal: subtotalExtraWallbox(item),
        meta: WALLBOX_EXTRAS_META[key],
      },
    ];
  });
}

export function validarExtrasWallboxProposta(extras: WallboxExtrasProposta): string | null {
  for (const key of WALLBOX_EXTRAS_KEYS) {
    const item = extras[key];
    if (!item.incluir) continue;
    const meta = WALLBOX_EXTRAS_META[key];
    if (valorExtraWallbox(item.valor) <= 0) {
      return `Informe um valor maior que zero para ${meta.label} ou desative a opção.`;
    }
    if (quantidadeExtraWallbox(item.quantidade) < 1) {
      return `Informe a quantidade de ${meta.label} (mínimo 1).`;
    }
  }
  return null;
}

type ColunasExtra = {
  incluir: string;
  preco: string;
  qtd: string;
};

export const WALLBOX_EXTRAS_COLUNAS: Record<WallboxExtraKey, ColunasExtra> = {
  projeto_celesc: {
    incluir: "wb_incluir_projeto_celesc",
    preco: "wb_preco_projeto_celesc",
    qtd: "wb_qtd_projeto_celesc",
  },
  projeto_cbmsc: {
    incluir: "wb_incluir_projeto_cbmsc",
    preco: "wb_preco_projeto_cbmsc",
    qtd: "wb_qtd_projeto_cbmsc",
  },
  botao_emergencia: {
    incluir: "wb_incluir_botao_emergencia",
    preco: "wb_preco_botao_emergencia",
    qtd: "wb_qtd_botao_emergencia",
  },
  pintura_sinalizacao: {
    incluir: "wb_incluir_pintura_sinalizacao",
    preco: "wb_preco_pintura_sinalizacao",
    qtd: "wb_qtd_pintura_sinalizacao",
  },
  sdai: {
    incluir: "wb_incluir_sdai",
    preco: "wb_preco_sdai",
    qtd: "wb_qtd_sdai",
  },
  infraestrutura: {
    incluir: "wb_incluir_infraestrutura",
    preco: "wb_preco_infraestrutura",
    qtd: "wb_qtd_infraestrutura",
  },
  mao_obra: {
    incluir: "wb_incluir_mao_obra",
    preco: "wb_preco_mao_obra",
    qtd: "wb_qtd_mao_obra",
  },
  quadro_transferencia: {
    incluir: "wb_incluir_quadro_transferencia",
    preco: "wb_preco_quadro_transferencia",
    qtd: "wb_qtd_quadro_transferencia",
  },
  clamper: {
    incluir: "wb_incluir_clamper",
    preco: "wb_preco_clamper",
    qtd: "wb_qtd_clamper",
  },
  controladores_carga: {
    incluir: "wb_incluir_controladores_carga",
    preco: "wb_preco_controladores_carga",
    qtd: "wb_qtd_controladores_carga",
  },
  move: {
    incluir: "wb_incluir_move",
    preco: "wb_preco_move",
    qtd: "wb_qtd_move",
  },
};

export type WallboxExtrasColunasBanco = {
  wb_incluir_projeto_celesc: boolean;
  wb_preco_projeto_celesc: number;
  wb_qtd_projeto_celesc: number;
  wb_incluir_projeto_cbmsc: boolean;
  wb_preco_projeto_cbmsc: number;
  wb_qtd_projeto_cbmsc: number;
  wb_incluir_botao_emergencia: boolean;
  wb_preco_botao_emergencia: number;
  wb_qtd_botao_emergencia: number;
  wb_incluir_pintura_sinalizacao: boolean;
  wb_preco_pintura_sinalizacao: number;
  wb_qtd_pintura_sinalizacao: number;
  wb_incluir_sdai: boolean;
  wb_preco_sdai: number;
  wb_qtd_sdai: number;
  wb_incluir_infraestrutura: boolean;
  wb_preco_infraestrutura: number;
  wb_qtd_infraestrutura: number;
  wb_incluir_mao_obra: boolean;
  wb_preco_mao_obra: number;
  wb_qtd_mao_obra: number;
  wb_incluir_quadro_transferencia: boolean;
  wb_preco_quadro_transferencia: number;
  wb_qtd_quadro_transferencia: number;
  wb_incluir_clamper: boolean;
  wb_preco_clamper: number;
  wb_qtd_clamper: number;
  wb_incluir_controladores_carga: boolean;
  wb_preco_controladores_carga: number;
  wb_qtd_controladores_carga: number;
  wb_incluir_move: boolean;
  wb_preco_move: number;
  wb_qtd_move: number;
};

export function serializarExtrasWallboxProposta(
  extras: WallboxExtrasProposta
): WallboxExtrasColunasBanco {
  const payload = {} as WallboxExtrasColunasBanco;
  for (const key of WALLBOX_EXTRAS_KEYS) {
    const item = extras[key];
    const colunas = WALLBOX_EXTRAS_COLUNAS[key];
    const incluir = Boolean(item.incluir);
    (payload as Record<string, boolean | number>)[colunas.incluir] = incluir;
    (payload as Record<string, boolean | number>)[colunas.preco] = incluir
      ? valorExtraWallbox(item.valor)
      : 0;
    (payload as Record<string, boolean | number>)[colunas.qtd] = incluir
      ? quantidadeExtraWallbox(item.quantidade)
      : 1;
  }
  return payload;
}

export function parseExtrasWallboxProposta(
  row: Record<string, unknown>
): WallboxExtrasProposta {
  const extras = extrasPadraoWallboxProposta();
  for (const key of WALLBOX_EXTRAS_KEYS) {
    const colunas = WALLBOX_EXTRAS_COLUNAS[key];
    const valor = valorExtraWallbox(row[colunas.preco] as number | null | undefined);
    extras[key] = {
      incluir: Boolean(row[colunas.incluir]) || valor > 0,
      valor,
      quantidade: quantidadeExtraWallbox(row[colunas.qtd] as number | null | undefined),
    };
  }
  return extras;
}
